import { MenuItem, Stack, TextField } from "@mui/material";
import { ChangeEvent } from "react";

export function SingleSelection({
  title,
  onChange,
  options,
  selection,
  showTitle = true,
}: {
  title: string;
  onChange: (column: string) => void;
  options: { [label: string]: string };
  selection: string;
  showTitle?: boolean;
}) {
  const titleDiv = showTitle ? (
    <div
      role="label"
      style={{ alignContent: "center", display: "flex", flexWrap: "wrap" }}
    >
      {title}: &nbsp;
    </div>
  ) : (
    <></>
  );
  return (
    <Stack direction="row" data-testid={title}>
      {titleDiv}
      <TextField
        select
        size="small"
        id="columnSelector"
        title={title}
        value={selection}
        onChange={(
          event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => onChange(event.target.value)}
      >
        {Object.entries(options).map(([label, value]) => (
          <MenuItem selected={value === selection} value={value}>
            <span role={value === selection ? "displayvalue" : "optionvalue"}>
              {label}
            </span>
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
